import {
  createReusableStylesheet,
  iconFontReusableStylesheet,
  tcwebReusableStylesheet,
  viewerMenuOverridesReusableStylesheet,
  type ReusableStylesheet,
} from '@trimble/stylesheets';
import styles from '../styles.compiled.css?raw';

/**
 * Pre-expanded Tailwind for embedded hosts (web components) that bundle
 * `@trimble/ui-components` without the host app's PostCSS pipeline.
 * Requires `styles.compiled.css` from root `postinstall` or `trimble-ui-components:compile-styles`.
 */
export const uiComponentsEmbeddedStylesheet = createReusableStylesheet(
  'ui-components:styles',
  styles
);

export const uiComponentsEmbeddedStylesheets: readonly ReusableStylesheet[] = [
  tcwebReusableStylesheet,
  viewerMenuOverridesReusableStylesheet,
  iconFontReusableStylesheet,
  uiComponentsEmbeddedStylesheet,
];
